import {get, post, postJson} from './axios'

// 核心数据
export const getCoreData = p => get('/home/order/statistics', p);

// 公告
export const getNotice = p => get('/home/sysNotice/page', p);

// 获取首页(自营) 核心数据
export const getBusinessCoreData = p => get('/home/ownBusinessCoreData', p);

// 最近一次精准营销效果分析
export const getMarketingLast = p => get('/home/precision-marketing/last', p);

// 首页精准营销效果（查看更多）
export const precisionMore = p => get('/home/precision-marketing/more', p);

// 首页-获取首页轮播图
export const getHomeGetCarousel = p => postJson(`/mainInfoController/getBannerPrint?type=${p.type}&platform=${p.platform}`);

// 提交调查问卷
export const submitQuestionnaire = p => postJson('/home/commit-questionaire', p);

// 提交调查问卷
export const inspectQues = p => get('/home/is-commit-questionaire', p);
